import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { initAnalytics } from "./analytics/ga";
import App from "./App.tsx";
import "./i18n";
import "./index.css";
import { envConfig } from "./utils/config-utils";
import { clearPinLockOnFreshLogin } from "./utils/pin-lock-utils";

// Google Analytics 4 — inert unless the prod image build supplies VITE_GA_MEASUREMENT_ID.
initAnalytics({
  measurementId: import.meta.env.VITE_GA_MEASUREMENT_ID,
  enabled: envConfig.env === "prod",
  consentGated: true,
});

// Before the first render: the PIN lock reads its flag when it mounts.
clearPinLockOnFreshLogin(window.location.search);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
